import api from './api';

interface ValidateOtpRequest {
    otp: string;
    // captchaToken: string; NOTE: Temporarily disabling reCAPTCHA.
}

export const otpApi = api.injectEndpoints({
    endpoints: builder => ({
        sendOtp: builder.mutation({
            query: (_: void) => ({
                url: '/otp',
                method: 'post',
            }),
        }),
        validateOtp: builder.mutation({
            query: ({ otp }: ValidateOtpRequest) => ({
                url: '/otp/validate',
                method: 'post',
                data: { otp },
                meta: { UserID: '1' },
            }),
        }),
    }),
});

export const { useSendOtpMutation, useValidateOtpMutation } = otpApi;
